package com.flowyride.data.favorites

import com.flowyride.core.api.SavedPlaceDto
import com.flowyride.core.api.SavedPlacesApi
import com.flowyride.core.api.toDomain
import com.flowyride.core.api.toDto
import com.flowyride.core.domain.place.NewSavedPlace
import com.flowyride.core.domain.place.SavedPlace
import com.flowyride.core.domain.place.SavedPlaceEdit
import com.flowyride.core.domain.place.SavedPlaceRepository
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.delete
import io.ktor.client.request.get
import io.ktor.client.request.patch
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType

/**
 * Addresses stored on the FlowyRide server, on the signed-in rider's account.
 *
 * @param client a client carrying the session (see `withServerSession`).
 */
class HttpSavedPlaceRepository(
    private val client: HttpClient,
    baseUrl: String,
) : SavedPlaceRepository {

    private val baseUrl = baseUrl.trimEnd('/')

    override suspend fun list(): List<SavedPlace> = favoriteCall {
        client.get(baseUrl + SavedPlacesApi.PATH).ensureSuccess().body<List<SavedPlaceDto>>().map { it.toDomain() }
    }

    override suspend fun save(place: NewSavedPlace): SavedPlace = favoriteCall {
        client.post(baseUrl + SavedPlacesApi.PATH) {
            contentType(ContentType.Application.Json)
            setBody(place.toDto())
        }.ensureSuccess().body<SavedPlaceDto>().toDomain()
    }

    override suspend fun update(id: Long, edit: SavedPlaceEdit): SavedPlace = favoriteCall {
        client.patch(baseUrl + SavedPlacesApi.item(id)) {
            contentType(ContentType.Application.Json)
            setBody(edit.toDto())
        }.ensureSuccess().body<SavedPlaceDto>().toDomain()
    }

    override suspend fun delete(id: Long) {
        favoriteCall { client.delete(baseUrl + SavedPlacesApi.item(id)).ensureSuccess() }
    }
}
